import { Language } from './language';

export { Language } from './language';

export class SectionAccess {
  constructor(
    public readonly section: Section,
    public readonly role: SectionRole,
  ) {}
}

export class SiteAccess {
  constructor(
    public readonly siteId: number,
    public readonly sections?: SectionAccess[],
  ) {}

  getSectionAccess(section: Section): SectionAccess | undefined {
    if (!this.sections) {
      return undefined;
    }
    return this.sections.find((s) => s.section === section);
  }
}

export class UserIdentity {
  public isVerified: boolean;
  public email: string;
  public role: GlobalRole;
  public isSiteAdmin: boolean;
  public createdAt: number;
  public siteIds: number[];
  public sites: SiteAccess[] = new Array<SiteAccess>();
  public issuedAt: number;

  public isAdmin(): boolean {
    return this.role === GlobalRole.Admin;
  }

  public getSiteAccess(siteId: number): SiteAccess | undefined {
    if (!this.sites || this.sites.length === 0) {
      return undefined;
    }
    return this.sites.find((s) => s.siteId === siteId);
  }

  public getAllSiteIds(): number[] {
    if (this.siteIds) {
      return this.siteIds;
    }
    if (!this.sites) {
      return [];
    }
    return this.sites.map((s) => s.siteId);
  }
}

export enum GlobalRole {
  User,
  Admin,
}
export enum SectionRole {
  Manager,
  User,
}
export enum Section {
  CDP,
  Engage,
  Automate,
  Tracker,
  Analytics,
  Apps,
}

export enum EarlyAccessFeatures {
  NewCampaignEditor = 'NewCampaignEditor',
  BuzzCopilot = 'BuzzCopilot',
}

export enum MultiFactorType {
  Totp = 'Totp',
}

export enum LoginMethodType {
  Password = 'Password',
  Google = 'Google',
  LinkedIn = 'LinkedIn',
}
